var rmUtil = require("../rmlibrary_old/util");
var PDFBlockNode = require("./block");
var listMarkers = require("../list-marker");
var PDFTextNode = require("./text");
var StyleManager = require("../style-manager");
var PDFInlineBlockNode = require("./inline-block");

function PDFListMarkerNode(markerText, parent) {
    PDFInlineBlockNode.call(this, {}, null, parent);

    this.markerText = markerText;

    StyleManager.resolveStyles(this);
    StyleManager.computeStyles(this);
}
rmUtil.inherits(PDFListMarkerNode, PDFInlineBlockNode);

PDFListMarkerNode.prototype._getOptions = function() {
    var ret = PDFInlineBlockNode.prototype._getOptions.call(this);
    ret.marginRight = this.computedStyles.size * 0.5;
    return ret;
};

PDFListMarkerNode.prototype.generate = function(pdf) {
    var options = this._getOptions();
    options.width = pdf.doc.getStringUnitWidth(this.markerText, { kerning: [] }) * this.computedStyles.size;
    options.height = this.computedStyles.size * this.computedStyles.lineHeight;
    return pdf.inlineBlock(options, [pdf.text(PDFTextNode.prototype._getOptions.call(this), [this.markerText])]);
};

function PDFListItemNode() {
    PDFBlockNode.apply(this, arguments);
}
rmUtil.inherits(PDFListItemNode, PDFBlockNode);

PDFListItemNode.prototype._getOptions = function() {
    var ret = PDFBlockNode.prototype._getOptions.call(this);
    ret.size = this.computedStyles.size;
    ret.font = this.computedStyles.font;
    ret.color = this.computedStyles.color;
    return ret;
};

function findFirstText(children) {
    for (var i = 0; i < children.length; i++) {
        if (children[i] instanceof PDFTextNode) return children[i];
        if (Array.isArray(children[i].children)) {
            var firstText = findFirstText(children[i].children);
            if (firstText) return firstText;
        }
    }
}

PDFListItemNode.prototype.generate = function(pdf) {
    var listMarker = listMarkers[this.styles["list-style-type"] || "disc"];
    var position = this.styles["list-style-position"] || "outside";

    if (typeof listMarker === "function") {
        var index = this.parentElement.children.indexOf(this);
        listMarker = listMarker(index);
    }

    if (listMarker && position === "inside") {
        var firstText = findFirstText(this.children || []);
        if (!firstText) {
            firstText = new PDFTextNode({}, "marker", this, null, {});
            StyleManager.resolveStyles(firstText);
            StyleManager.computeStyles(firstText);
            firstText.setChildren([]);
            this.children.unshift(firstText);
        }
        var newNode = new PDFListMarkerNode(listMarker, this);
        firstText.children.unshift(newNode);
    }

    var options = this._getOptions();
    var pdfChildren = this.children.map(function(child) {
        return child.generate(pdf);
    });

    if (listMarker && position !== "inside") {
        options.markerText = listMarker;
        return pdf.listItem(options, pdfChildren);
    } else {
        return pdf.block(options, pdfChildren);
    }
};

module.exports = PDFListItemNode;
